import {
  ValidatorConstraint,
  ValidatorConstraintInterface,
} from 'class-validator';
import { uniqWith } from 'lodash';
import { MaterialCreatableInterface } from '../interfaces/material-creatable.interface';
import { MaterialCascadableInterface } from '../interfaces/material-cascadable.interface';

interface MaterialUniqueValidatorValue
  extends MaterialCreatableInterface,
    MaterialCascadableInterface {}

@ValidatorConstraint({ name: 'materialUnique', async: false })
export class MaterialUniqueValidator implements ValidatorConstraintInterface {
  validate(materials: MaterialUniqueValidatorValue[]) {
    const uniqFloors = uniqWith(
      materials,
      (a: MaterialUniqueValidatorValue, b: MaterialUniqueValidatorValue) => {
        return a.name === b.name && a.unit === b.unit;
      },
    );

    return materials.length === uniqFloors.length;
  }

  defaultMessage() {
    return 'Duplicate material name/unit combinations are not allowed on the same job.';
  }
}
